export default __webpack_public_path__ + "static/media/boton-volver.08d32def.svg";